<template>
  <database-layout>
    <div>Database Dashboard</div>
  </database-layout>
</template>
<script>
import DatabaseLayout from './Layout.vue'
export default {
  components: {
    DatabaseLayout
  }
}
</script>
